const formatRetentionBound = (bound: number): string => bound.toLocaleString('fr-FR');

export default formatRetentionBound;
